const RTL = new Set(['ar', 'he', 'fa', 'ur', 'yi', 'ps', 'sd', 'ug', 'dv', 'ku', 'ckb']);
export function direction(lang) {
    const base = lang.toLowerCase().split(/[-_]/)[0] ?? '';
    return RTL.has(base) ? 'rtl' : 'ltr';
}
//# sourceMappingURL=direction.js.map